export default "__VITE_ASSET__BWRzdfQY__"